module.exports = __webpack_public_path__ + "static/media/Zgrada11.a6301d4c.png";